import { render, staticRenderFns } from "./ApplicationFooter.vue?vue&type=template&id=0c26695c&"
import script from "./ApplicationFooter.vue?vue&type=script&lang=js&"
export * from "./ApplicationFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports